import './Founder.scss';

import Nav from './Nav';
import Footer from './Footer';
import { Button } from './Reusable';

import { HashLink as ScrollLink } from 'react-router-hash-link';
import useReveal from '../utility/useReveal';

// served straight out of public/ rather than imported through the bundler,
// which is where the file was dropped
const portrait = `${process.env.PUBLIC_URL}/team/John_G.jpg`;

// The personal page lives off the main scroll on purpose: the home page stays
// company-first, and the founder story is something a visitor opts into once
// they're already interested.
//
// Written in THIRD PERSON, and the CTA at the bottom speaks as "we" like every
// other CTA on the site. Nothing on the site narrates as "I" — the one exception
// is the attributed pull-quote in Impact, which is a quotation rather than the
// site talking. Keep it that way if this copy gets extended.
function Founder() {

    useReveal()

    return (
        <>
            <Nav />

            <div className="Founder">

                <div className="Founder-intro">
                    <div className="Founder-portrait reveal">
                        <img src={portrait} alt="Johnathan Geiger, founder of Candlelyte Productions" />
                    </div>

                    <div className="Founder-lead reveal delay-1">
                        <span className="Founder-eyebrow">Behind the camera</span>
                        <h1>Johnathan <b>Geiger</b></h1>
                        <p className="Founder-role">Founder &middot; Director &middot; Cinematographer &middot; Editor</p>

                        <p>There are churches and organizations everywhere doing extraordinary work
                        that almost nobody hears about. Not for lack of a story — telling one well is
                            simply its own craft. That gap is why Candlelyte exists.</p>

                        <p>On every project, the part Johnathan cares most about is getting the message
                        right: what actually needs to be said, and what will make it land with the people
                        you need to reach. Everything after that is craft in service of the answer.</p>

                        <ul className="Founder-facts">
                            <li><b>Minneapolis</b><span>Based in the Twin Cities, working across Minnesota and beyond</span></li>
                            <li><b>Mission-driven</b><span>Parish, nonprofit, and cause-led storytelling</span></li>
                            <li><b>Start to finish</b><span>Directing, shooting, and editing through final delivery</span></li>
                        </ul>
                    </div>
                </div>

                <div className="Founder-body">
                    <div className="Founder-story reveal">
                        <h2>How he got here</h2>

                        <p>Johnathan got into film for what the visual medium can do that nothing else
                        can: put someone in the room with a story and let them feel it. The first real
                        project he shot was a short film, and mostly it taught him how much he still had
                        to learn. He went looking for that craft anywhere he could find it: parish work,
                        nonprofits, weddings, narrative.</p>

                        <p>The parish work is what pointed him here. He started making videos for his own
                        parish, and they worked. They helped raise real money, and that money went
                        back into reaching more souls for Christ.</p>

                        <p>That's why Candlelyte exists. He isn't showing up to shoot a job — he's
                        showing up to support missions he believes in. The film is just how he does it.</p>
                    </div>

                    {/* covers the same three phases as the home page Process section,
                        deliberately: there it's the pitch, here it's how one person
                        actually runs it */}
                    <aside className="Founder-approach reveal delay-1">
                        <h2>How he works</h2>
                        <p>It starts with the message. Before anything else, he wants to know exactly
                        what has to come across and who it has to reach. Every decision after that
                        answers to it.</p>

                        <ol className="Founder-approach-steps">
                            <li>
                                <b>Pre-production</b>
                                <span>Copy, tone, and shot lists planned out in advance, so the final
                                edit holds no surprises.</span>
                            </li>
                            <li>
                                <b>Production</b>
                                <span>Shot by Johnathan, or by a nimble team sized to what the
                                project actually needs.</span>
                            </li>
                            <li>
                                <b>Post-production</b>
                                <span>Nothing gets thrown together and shipped. The cut and the color
                                grade are worked until the story lands the way the mission needs it to.</span>
                            </li>
                        </ol>

                        <p className="Founder-approach-note">Every step is built around the message
                        we started with. That's what makes the finished film land with the people you
                        made it for.</p>
                    </aside>
                </div>

                <div className="Founder-cta reveal">
                    <h2>Let's talk about your story.</h2>
                    <p>Tell us what you're working on. If Candlelyte isn't the right fit, we'll say so
                    and point you somewhere that is.</p>
                    <div className="Founder-cta-actions">
                        <Button title="Get in touch" flameon={true} source="Founder page" />
                        <ScrollLink to="/#process" className="Founder-back">See how we work</ScrollLink>
                    </div>
                </div>

            </div>

            <Footer />
        </>
    );
}

export default Founder;
